export const _setSelectedStudentTrackers = (state, action) => {
  state.selectedStudentTrackers = action.payload;
};
